import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

import ApplicationConfigListItem from '../components/ApplicationConfigListItem';

export default class ApplicationConfigList extends Component {
    view() {
        const application = this.attrs.application;
        const configs = this.attrs.configs;

        if (configs) {
            return configs.length ? configs.map((config) => {
                return (
                    <div className='ApplicationConfigList-group'>
                        <ApplicationConfigListItem application={application} config={config} />
                    </div>
                );
            }) : <p className='ApplicationConfigList-empty'>{ app.translator.trans('xtreh-phoenix.forum.applications.configs.not_found') }</p>;
        }

        return <LoadingIndicator size='large' display='block' />;
    }
}
